import React, { createContext, useContext, useState } from 'react';

const ScoutContext = createContext();

export const useScoutContext = () => useContext(ScoutContext);

export const ScoutProvider = ({ children }) => {
    const [scoutState, setScoutState] = useState({
        jobid: '',
        jobcode: '',
        scoutactivestatus: 'all',
    });

    const updateScoutState = (newState) => {
        setScoutState((prevState) => ({ ...prevState, ...newState }));
    };

    return (
        <ScoutContext.Provider value={{ scoutState, updateScoutState }}>
            {children}
        </ScoutContext.Provider>
    );
};
